import { health } from '@/api/activity'

/**
 * 从用户信息与健康资料接口组装权益人展示信息
 * @param {Object} userInfo
 * @returns {Promise<{ name: string, phone: string, idNo: string }>}
 */
export async function fetchBeneficiaryInfo(userInfo = {}) {
  const fallback = {
    name: userInfo.name || userInfo.userName || '',
    phone: userInfo.userPhone || userInfo.phone || '',
    idNo: userInfo.idNo || userInfo.idCard || ''
  }

  try {
    const res = await health()
    if (res && (res.code == 1000 || res.code === '1000') && res.data) {
      return {
        name: res.data.name || fallback.name,
        phone: res.data.userPhone || fallback.phone,
        idNo: res.data.idNo || fallback.idNo
      }
    }
  } catch (error) {
    console.error('获取权益人信息失败:', error)
  }

  return fallback
}

/**
 * 激活权益卡前核验 mixin
 */
export const activateBeneficiaryConfirmMixin = {
  data() {
    return {
      /** @type {boolean} */
      showBeneficiaryConfirmModal: false,
      /** @type {boolean} */
      beneficiaryConfirmed: false,
      /** @type {{ name: string, phone: string, idNo: string }} */
      beneficiaryInfo: {
        name: '',
        phone: '',
        idNo: ''
      }
    }
  },
  methods: {
    /**
     * 重置权益人核验状态
     */
    resetBeneficiaryConfirmState() {
      this.beneficiaryConfirmed = false
      this.showBeneficiaryConfirmModal = false
    },

    /**
     * 加载权益人信息
     */
    async loadBeneficiaryInfo() {
      this.beneficiaryInfo = await fetchBeneficiaryInfo(this.userInfo || {})
    },

    /**
     * 激活弹框 - 确定按钮点击
     */
    onActivateConfirmClick() {
      if (!this.cardCode || !this.cardCode.trim()) {
        this.$message('请输入实体卡权益码', 'warning')
        return
      }

      if (!this.beneficiaryConfirmed) {
        this.showBeneficiaryConfirmModal = true
        return
      }

      this.handleActivate()
    },

    /**
     * 权益人信息核验确认
     */
    onBeneficiaryConfirm() {
      this.beneficiaryConfirmed = true
      this.showBeneficiaryConfirmModal = false
    },

    /**
     * 权益人信息核验取消
     */
    onBeneficiaryCancel() {
      this.showBeneficiaryConfirmModal = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/activateBeneficiaryConfirm.js